import { useTranslation } from 'react-i18next';

// interface Props {
//     type: string
// }

export const OrderInfoBadge = ({ type, time, tableNumber }) => {
    const { t } = useTranslation();

    return (
        <div className="text-[13px] font-medium">
            {!!(type === 'pickup' || type === 'delivery') && (
                <span className="capitalize">
                    {t(`order_type.${type}`)} <span className="lowercase">{time}</span>
                </span>
            )}
            {type === 'dinein' && (
                <span>
                    {t(`Table`)} {tableNumber}
                </span>
            )}
        </div>
    );
};
